export class EndpointPredefinedMessageModel {
  _id?: any;
  uuid: string;
  predefined_message_uuid: string;
  endpoint_uuid: string;
  sending_criteria: SendingCriteria;
  create_date: Date;
  update_date: Date;
  created_by: string;
  updated_by: string;
  revision: string;
  status: string;
  vrsn: string;
}

export class SendingCriteria {
  criteria: string;
  value?: string;
}
